const checkRequired = (value) => {
  if (!value || (typeof value === 'string' && !value.trim())) {
    return 'Required';
  }
};

const validateEmailFormat = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return 'Invalid email address';
  }
};

const validateLength = (key, value, min) => {
  if (value.length < min) {
    return `${key} must be at least ${min} characters`;
  }
};

const removeUndefined = (obj) =>
  Object.keys(obj)
    .filter((key) => obj[key] !== undefined)
    .reduce((res, key) => {
      res[key] = obj[key];
      return res;
    }, {});

const validateLogin = async ({ email, password }) => {
  const errors = removeUndefined({
    email: checkRequired(email) || validateEmailFormat(email),
    password: checkRequired(password),
  });

  return errors;
};

export default validateLogin;
